var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTranslate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M16.015 15.62h-.624a.3.3 0 0 1-.174-.052.3.3 0 0 1-.096-.132l-.324-.885H13l-.324.885a.3.3 0 0 1-.096.126.26.26 0 0 1-.171.057h-.627l1.704-4.338h.825zm-2.808-1.639h1.383l-.528-1.443-.081-.225a7 7 0 0 1-.084-.285 7 7 0 0 1-.162.516zm-4.332.495-.403-.41 1.902-1.935a5 5 0 0 1-.63-.806 5.7 5.7 0 0 1-.49-.95h.608a5.3 5.3 0 0 0 .915 1.347q.407-.417.77-1.014c.363-.597.413-.767.513-1.11H7.99v-.582h2.506v-.627h.574v.627h2.507v.582h-.936a6.2 6.2 0 0 1-.593 1.368q-.406.714-.869 1.177l.944.982-.217.598-1.13-1.177z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTranslate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/translate.8b4af3ed.svg";